import { render, staticRenderFns } from "./CabinetDetail.vue?vue&type=template&id=d665ef22&scoped=true"
import script from "./CabinetDetail.vue?vue&type=script&lang=js"
export * from "./CabinetDetail.vue?vue&type=script&lang=js"
import style0 from "./CabinetDetail.vue?vue&type=style&index=0&id=d665ef22&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d665ef22",
  null
  
)

export default component.exports